import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_line = _resolveComponent("skeleton-line")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.itemsArray, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item,
        class: "_flex _bxsh--base _ai-c _jc-sb _px-2 _py-2 _bgc--white _rounded--common _pos-r gfu-background-swept"
      }, [
        _createVNode(_component_skeleton_line, {
          class: "_flex-basis-70",
          height: 20
        }),
        _createVNode(_component_skeleton_line, {
          class: "_flex-basis-10",
          height: 20
        })
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}